import axios from '@/utils/axios';
import { ip3 } from '@/utils/constants';

export async function getKhauPhanAn(payload: {
  page: number;
  limit: number;
  cond?: any;
  loaiHinh?: string;
  sort?: any;
}) {
  const { page, limit, cond, loaiHinh, sort } = payload;
  return axios.get(`${ip3}/khau-phan-an/pageable`, {
    params: {
      page,
      limit,
      cond: {
        loaiHinh,
        ...cond,
      },
      sort,
    },
  });
}

export async function addKhauPhanAn(payload: any) {
  return axios.post(`${ip3}/khau-phan-an/many`, payload);
}
export async function checkXuatKho(
  truongId: string,
  data: { ngay: number; thang: number; nam: number },
) {
  return axios.get(`${ip3}/khau-phan-an/check-xuat-kho/truong/${truongId}`, {
    params: data,
  });
}
export async function checkImportTemplate(id: string, donViId: string) {
  return axios.get(`${ip3}/kho-thuc-don-mau/${id}/don-vi/${donViId}`);
}
export async function addThongTinKhauPhanAn(payload: any) {
  return axios.post(`${ip3}/thong-tin-khau-phan-an`, payload);
}

export async function dieuChinhKhauPhanAn(payload: any) {
  return axios.post(`${ip3}/khau-phan-an/dieu-chinh`, payload);
}

export async function updKhauPhanAn(payload: any) {
  const { id } = payload;
  return axios.put(`${ip3}/khau-phan-an/${id}`, payload);
}

export async function updThongTinKhauPhanAn(payload: any) {
  const { id } = payload;
  return axios.put(`${ip3}/thong-tin-khau-phan-an/${id}`, payload);
}

export async function delKhauPhanAn(payload: any) {
  const { id } = payload;
  return axios.delete(`${ip3}/khau-phan-an/${id}`);
}

export async function exportKhauPhanAn(payload: any) {
  const { id } = payload;
  return axios.put(`${ip3}/khau-phan-an/${id}/xuat-kho`, null, { params: payload });
}
export async function exportKhauPhanAnV2(payload: any) {
  const { id } = payload;
  return axios.put(`${ip3}/khau-phan-an/${id}/xuat-kho-v2`, null, { params: payload });
}

export async function exportMau1(payload: any) {
  const { donViId } = payload;
  return axios.get(`${ip3}/khau-phan-an/export/mau-1/${donViId}`, {
    responseType: 'arraybuffer',
    params: payload,
  });
}
export async function exportMau2(payload: any) {
  const { donViId } = payload;
  return axios.get(`${ip3}/khau-phan-an/export/mau-2/${donViId}`, {
    responseType: 'arraybuffer',
    params: payload,
  });
}
export async function exportMau3(payload: any) {
  const { donViId } = payload;
  return axios.get(`${ip3}/khau-phan-an/export/mau-3/${donViId}`, {
    responseType: 'arraybuffer',
    params: payload,
  });
}
export async function exportMau4() {
  return axios.get(`${ip3}/khau-phan-an/export/mau-4`, {
    responseType: 'arraybuffer',
  });
}
export async function exportMau5(payload: any) {
  const { donViId } = payload;
  return axios.get(`${ip3}/khau-phan-an/export/mau-5/${donViId}`, {
    responseType: 'arraybuffer',
    params: payload,
  });
}
export async function canhBaoNhapKho(payload: any) {
  return axios.post(`${ip3}/khau-phan-an/canh-bao-hang-kho`, payload);
}
export async function getKhauPhanAnV2(payload: {
  page: number;
  limit: number;
  ngayBatDau: string;
  ngayKetThuc: string;
  cond?: any;
  loaiHinh?: string;
  sort?: any;
}) {
  const { page, limit, cond, loaiHinh, sort, ngayBatDau, ngayKetThuc } = payload;
  return axios.get(`${ip3}/khau-phan-an/pageable/v2`, {
    params: {
      // page,
      // limit,
      ngayBatDau,
      ngayKetThuc,
      cond: {
        loaiHinh,

        ...cond,
      },
      sort,
    },
  });
}
